import { createLucideIcon } from "lucide-react";

export const Sorting1 = createLucideIcon(
    "Sorting1",
    [
        [
            "path",
            {
                d: "M11 12H16",
                key: "h8bb4r",
            },
        ],
        [
            "path",
            {
                d: "M11 16H14",
                key: "1b3gm8",
            },
        ],
        [
            "path",
            {
                d: "M11 4H21",
                key: "1om0w0",
            },
        ],
        [
            "path",
            {
                d: "M11 8L19 8.00006",
                key: "m0nmyz",
            },
        ],
        [
            "path",
            {
                d: "M5.5 21C4.7998 21 3.4915 19.0057 3 18.5",
                key: "nkc38e",
            },
        ],
        [
            "path",
            {
                d: "M5.5 21C6.2002 21 7.5085 19.0057 8 18.5",
                key: "1yvnig",
            },
        ],
        [
            "path",
            {
                d: "M5.5 21V3",
                key: "1mc4pb",
            },
        ],
    ],
);
